import { useNavigate } from "react-router-dom";
import { AppThemeToggle } from "../../../components/AppThemeToggle";
import { MobileAccountTrigger } from "../../../account/MobileAccountMenu";
import { FswlPublicBrand } from "../../../components/BrandLockup";
import { StaffBottomNav } from "./StaffBottomNav";
import { StaffHeaderIconButton } from "./StaffHeaderIconButton";
import { StaffBellIcon, StaffChevronLeftIcon } from "./StaffHeaderIcons";

type StaffAppShellProps = {
  title?: string;
  showBack?: boolean;
  backTo?: string;
  headerAction?: React.ReactNode;
  hideNav?: boolean;
  children: React.ReactNode;
};

export function StaffAppShell({
  title,
  showBack,
  backTo = "/staff",
  headerAction,
  hideNav,
  children,
}: StaffAppShellProps) {
  const navigate = useNavigate();

  return (
    <div className="staff-app">
      <header className="staff-app-header">
        <div className="staff-app-header__brand">
          {showBack ? (
            <StaffHeaderIconButton aria-label="Go back" onClick={() => navigate(backTo)}>
              <StaffChevronLeftIcon />
            </StaffHeaderIconButton>
          ) : (
            <div className="staff-app-header__lockup">
              <FswlPublicBrand />
            </div>
          )}
        </div>
        {title ? (
          <h1 className="staff-app-header__title" id="staff-page-title">
            {title}
          </h1>
        ) : (
          <span className="staff-app-header__title-spacer" aria-hidden="true" />
        )}
        <div className="staff-app-header__actions">
          {headerAction}
          <StaffHeaderIconButton aria-label="Notifications" to="/staff/notifications">
            <StaffBellIcon />
          </StaffHeaderIconButton>
          <MobileAccountTrigger />
          <AppThemeToggle className="staff-header-btn theme-icon-button" />
        </div>
      </header>
      <main className="staff-app-main" aria-labelledby={title ? "staff-page-title" : undefined}>
        {children}
      </main>
      {!hideNav ? <StaffBottomNav /> : null}
    </div>
  );
}
